import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { useMsal } from "@azure/msal-react";
import { Tabs, Tab } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";

import "../../SignInModule/SignIn.scss";

import { Input } from "abs-ui-components";

import absLogo from "../../../images/abs-logo-white.svg";
import { emitToasterMsg } from "../../../services/toasterUtility";
import RegistartionPage from "../Registration/Registration";
import { APP_TITLE } from "../../../common/header/constants";
import { validateSigninUser } from "../../../services/signInService";
import {
	setUserInfo,
	setUserLoggedIn,
} from "../../../store/userInfo/userInfo.slice";
import axiosHttp from "../../../services/interceptor";

const SsoLogin = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { instance, inProgress } = useMsal();
	const [showProceed, setshowProceed] = useState(false);
	const [proceedText, setProceedText] = useState(false);
	const [selectedTab, setSelectedTab] = useState();

	const [registerStatus, setRegisterStatus] = useState(true);
	const [isInteractionInProgress, setIsInteractionInProgress] =
		useState(false);
	const [showPassword, setShowPassword] = useState(false);

	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const handleLogin = async (formdata) => {
		const signInObj = {
			email: formdata?.Email?.trim(),
			password: formdata?.password?.trim(),
		};
		const signInResponse = await validateSigninUser(signInObj);

		if (
			signInResponse &&
			signInResponse?.isSuccess !== undefined &&
			!signInResponse?.isSuccess
		) {
			emitToasterMsg("error", "Invalid User Name or Password.");
		} else if (
			signInResponse?.isSuccess &&
			signInResponse?.bearerToken &&
			signInResponse?.user
		) {
			await handleAccessToken(signInResponse?.bearerToken);
			// localStorage.setItem("loginStatus", true);
			dispatch(setUserInfo(signInResponse?.user));
			dispatch(setUserLoggedIn(true));
			navigate("/");
		}
	};

	const handleAccessToken = async (token) => {
		try {
			const res = await axiosHttp({
				url: `api/Accounts/StoreCookie`,
				method: "POST",
				data: { accessToken: token },
			});
		} catch (error) {
			console.error(error);
		}
	};

	const register = () => {
		setRegisterStatus(false);
	};

	const handleTabChange = (event, newValue) => {
		setSelectedTab(newValue);
		localStorage.setItem("selectedTabIndex", newValue);
		if (newValue === 0) {
			handleADSignIn();
		} else if (newValue === 1) {
			handleB2CSignIn();
		}
	};

	const handleADSignIn = async () => {
		//switchToAD();
		localStorage.setItem("authType", "ad");
		window.location.reload();
	};

	const proceedToLogin = async () => {
		if (
			isInteractionInProgress ||
			inProgress === "login" ||
			inProgress === "acquireToken"
		) {
			return;
		}
		setIsInteractionInProgress(true);
		try {
			await instance.loginRedirect({
				scopes: ["openid", "profile", "offline_access"],
			});
		} catch (error) {
			console.error("Login failed:", error);
		} finally {
			setIsInteractionInProgress(false);
		}
	};

	const handleB2CSignIn = async () => {
		//switchToB2C();
		localStorage.setItem("authType", "b2c");
		window.location.reload();
	};

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	useEffect(() => {
		const savedTabIndex = localStorage.getItem("selectedTabIndex");
		if (savedTabIndex !== null) {
			setSelectedTab(parseInt(savedTabIndex, 10));
		}
		let authType = localStorage.getItem("authType") ?? "";
		if (authType !== "") {
			setshowProceed(true);
			if (authType === "ad") {
				setProceedText("Proceed with Microsoft");
			} else {
				setProceedText("Proceed with Client Sign in");
			}
		}
	}, []);

	return (
		<>
			{registerStatus ? (
				<div className="main-container">
					<div className="row justify-content-center align-items-center vh-100">
						<div className="login-container d-flex justify-content-center align-items-center">
							<div>
								<div className="text-center mt-3">
									<img
										className="abs-logo"
										src={absLogo}
										alt="abs-logo"
									/>
								</div>
								<p className="emmision-text mt-3">
									{APP_TITLE}
								</p>

								<h4 className="login mt-3"> Sign in </h4>
								<form onSubmit={handleSubmit(handleLogin)}>
									<div className="input-content mt-3">
										<Controller
											name="Email"
											control={control}
											defaultValue=""
											rules={{
												required: "Email is required",
												pattern: {
													value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
													message:
														"Invalid email address",
												},
											}}
											render={({ field }) => (
												<>
													<Input
														required
														id="username"
														onChange={(e) => {
															const emailValue =
																e.trim();
															field.onChange(
																emailValue
															);
														}}
														placeholder="Email"
														value={field.value}
														autoFocus={false}
														className="username"
													/>
												</>
											)}
										/>
									</div>
									<span>
										{errors.Email && (
											<p className="error">
												{errors.Email.message}
											</p>
										)}
									</span>

									<div className="input-content mt-3">
										<Controller
											name="password"
											control={control}
											defaultValue=""
											rules={{
												required:
													"Password is required",
											}}
											render={({ field }) => (
												<>
													<div className="password-wrapper">
														<Input
															required
															id="password"
															onChange={(e) => {
																const passwordValue =
																	e.trim();
																field.onChange(
																	passwordValue
																);
															}}
															type={
																showPassword
																	? "text"
																	: "password"
															}
															value={field.value}
															autoFocus={false}
															className="password"
															placeholder="Password"
														/>
														<span
															className="toggle-password"
															onClick={
																togglePasswordVisibility
															}
														>
															<FontAwesomeIcon
																icon={
																	showPassword
																		? faEyeSlash
																		: faEye
																}
															/>
														</span>
													</div>
												</>
											)}
										/>
									</div>

									<span>
										{errors.password && (
											<p className="error">
												{errors.password.message}
											</p>
										)}
									</span>

									<button
										type="submit"
										className="Sign-In text-center "
									>
										Sign in
									</button>
								</form>

								<div className=" mt-3">
									{/* <p className="login-with text-center"> or </p> */}

									<div className="">
										<p className="text-center login-with">
											or
										</p>

										<div className="d-flex justify-content-center">
											<Tabs
												value={selectedTab}
												onChange={handleTabChange}
												aria-label="sign-in tabs"
												className="sign-in-tabs"
											>
												<Tab
													label="AD Sign In"
													sx={{
														color: "white",
														"&.Mui-selected": {
															color: "#002A4E",
														},
													}}
												/>
												<Tab
													label="Client Sign In"
													sx={{
														color: "white",
														"&.Mui-selected": {
															color: "#002A4E",
														},
													}}
												/>
											</Tabs>
										</div>
									</div>

									{showProceed && (
										<div className="text-center mt-4">
											<button
												className="mt-1 ml-4 proceed-button"
												onClick={proceedToLogin}
											>
												{proceedText}
											</button>
										</div>
									)}

									<div className="text-center mt-4">
										<p
											className="register text-center"
											onClick={register}
										>
											Register
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<RegistartionPage />
			)}
		</>
	);
};
export default SsoLogin;
